module.exports = __webpack_public_path__ + "img/rzwf01.4cc712bd.jpg";